import { getJWTDecoded, writeLog } from "../../helpers/helpers";

export async function logFileUpload(metadata: object) {
  const { error } = metadata as { error?: any };
  if (error) {
    // local debugging
    console.error(metadata);

    // JSON.stringify() of a JavaScript Error returns only {}, so preserve useful fields
    if (error instanceof Error) {
      (metadata as { error?: any }).error = JSON.stringify({
        message: error.message,
        stack: error.stack,
      });
    }
  } else {
    // local debugging
    console.log(metadata);
  }

  const userInfo = getJWTDecoded();
  const userName = `${userInfo.firstName} ${userInfo.lastName}`;

  // Production debugging goes through the PBEEJ API.
  // Cloud Logging was skipped: the OAuth scope was awkward, and most users cannot call that endpoint.
  await writeLog({
    metadata,
    userName,
  });
}